import { useRef, useState } from "react";
import { Dir } from "@/game/types";
import { StickSize } from "@/game/storage";

export const Joystick = ({ onHold, size = "m" }: { onHold: (d: Dir | null) => void; size?: StickSize }) => {
  const zone = useRef<HTMLDivElement>(null);
  const origin = useRef<{ x: number; y: number } | null>(null);
  const [vis, setVis] = useState<{ x: number; y: number; kx: number; ky: number } | null>(null);
  const last = useRef<Dir | null>(null);

  const local = (e: React.PointerEvent) => { const r = zone.current!.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top, w: r.width }; };
  const emit = (d: Dir | null) => { if (d !== last.current) { last.current = d; onHold(d); } };

  const down = (e: React.PointerEvent) => {
    e.preventDefault();
    zone.current!.setPointerCapture(e.pointerId);
    const p = local(e);
    origin.current = p;
    setVis({ x: p.x, y: p.y, kx: 0, ky: 0 });
  };
  const move = (e: React.PointerEvent) => {
    if (!origin.current) return;
    const p = local(e);
    let dx = p.x - origin.current.x, dy = p.y - origin.current.y;
    const len = Math.hypot(dx, dy), max = p.w * 0.24, dead = p.w * 0.075;
    if (len > max) { dx *= max / len; dy *= max / len; }
    setVis({ x: origin.current.x, y: origin.current.y, kx: dx, ky: dy });
    if (len < dead) { emit(null); return; }
    emit(Math.abs(dx) > Math.abs(dy) ? (dx > 0 ? "right" : "left") : dy > 0 ? "down" : "up");
  };
  const up = () => { origin.current = null; setVis(null); emit(null); };

  return (
    <div ref={zone} data-testid="virtual-joystick" data-size={size} className={`joystick-zone joystick-zone--${size} touch-none select-none`} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up} onLostPointerCapture={up}>
      {!vis && <span className="joystick-hint" aria-hidden />}
      {vis && (
        <>
          <span className="joystick-base" style={{ left: vis.x, top: vis.y }} />
          <span className="joystick-knob" style={{ left: vis.x + vis.kx, top: vis.y + vis.ky }} />
        </>
      )}
    </div>
  );
};
